import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PDFFiles } from "../../components/PDFFiles";

export interface IPDFFilesPage {}

export const PDFFilesPage: FC<IPDFFilesPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="PDF Files"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'PDF Files', navigateTo: '/pdf-files'}]}
      mainContents={<PDFFiles />}
    />
  );
};
